var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "blue-section" }, [
        _c("div", { staticClass: "back-btn-container" }),
        _vm._v(" "),
        _c("div", { staticClass: "container", style: _vm.coverImageStyle }, [
          _c(
            "div",
            { staticClass: "blue-section-inner" },
            [
              _vm.uploadShow
                ? _c("UploadButton", { on: { click: _vm.addModalOpen } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "square" }, [
                _vm.user.profile_image && _vm.user.profile_image.url
                  ? _c("img", {
                      staticClass: "square-img",
                      attrs: {
                        src: _vm.user.profile_image.url,
                        width: "317",
                        height: "317",
                        loading: "lazy",
                        alt: `${_vm.user.username} profile image`,
                      },
                    })
                  : _c("span", { staticClass: "image-placeholder" }),
              ]),
              _vm._v(" "),
              _vm.$route.name === "ArtistsAlbumDetails" ||
              _vm.$route.name === "AlbumsPage"
                ? _c(
                    "a",
                    { staticClass: "back-btn", on: { click: _vm.routerBack } },
                    [_c("span", [_vm._v("Back to all albums")])]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "user-info" }, [
          _c("p", { staticClass: "user-name" }, [
            _vm._v(_vm._s(_vm.user.full_name)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "user-nickname" }, [
            _vm._v("@" + _vm._s(_vm.user.username)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "followers-panel", attrs: { id: "user-info" } },
            [
              _vm.user.show_follow_info
                ? _c("div", { staticClass: "followers-stats" }, [
                    _c("div", { staticClass: "follower-info" }, [
                      _c("span", { staticClass: "counter" }, [
                        _vm._v(_vm._s(_vm.user.followers_count)),
                      ]),
                      _vm._v(" Followers\n                    "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "follower-info" }, [
                      _c("span", { staticClass: "counter" }, [
                        _vm._v(_vm._s(_vm.user.followings_count)),
                      ]),
                      _vm._v(" Following\n                    "),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.profile || (_vm.user && _vm.currentUser.id === _vm.user.id)
                ? _c(
                    "button",
                    {
                      staticClass: "edit-profile-button",
                      on: { click: _vm.toEditProfilePage },
                    },
                    [
                      _vm._v(
                        "\n                    Edit Profile\n                "
                      ),
                    ]
                  )
                : _vm.isAuthenticated &&
                  _vm.currentUser.id != _vm.$route.query.user_id
                ? _c(
                    "button",
                    {
                      staticClass: "edit-profile-button",
                      on: { click: _vm.followToggle },
                    },
                    [
                      !_vm.user.followed
                        ? [_vm._v(" Follow ")]
                        : [_vm._v(" Unfollow ")],
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "description",
              class: { empty: !_vm.user.description },
            },
            [
              _c("textarea-autosize", {
                staticClass: "description-text",
                attrs: { readonly: "" },
                model: {
                  value: _vm.user.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.user, "description", $$v)
                  },
                  expression: "user.description",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.$route.name === "ArtistsAlbumDetails" ||
      _vm.$route.name === "AlbumsPage"
        ? _c(
            "a",
            { staticClass: "back-btn mobile", on: { click: _vm.routerBack } },
            [_c("span", [_vm._v("Albums")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmModal
        ? _c("ConfirmUserModal", { on: { modalClose: _vm.confirmModalClose } })
        : _vm._e(),
      _vm._v(" "),
      _vm.addModal
        ? _c("AddModal", {
            attrs: { loadData: "" },
            on: { addModalClose: _vm.addModalClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }